import { alertConstants } from "../../constants/alert.constants";

const defaultState = {
  show: false,
  title: '',
  type: '',
  message: ''
}

export function alert(state = defaultState, action) {
  switch (action.type) {
    case alertConstants.SUCCESS:
      return {
        type: alertConstants.SUCCESS,
        title: action.title,
        message: action.message,
        show: true
      };
    case alertConstants.INFO:
      return {
        type: alertConstants.INFO,
        title: action.title,
        message: action.message,
        show: true
      };
    case alertConstants.ERROR:
      return {
        type: alertConstants.ERROR,
        title: action.title,
        message: action.message,
        show: true
      };
    case alertConstants.WARNING:
      return {
        type: alertConstants.WARNING,
        title: action.title,
        message: action.message,
        show: true
      };
    case alertConstants.CLEAR:
      return defaultState
    default:
      return state;
  }
}
